RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _, branding) {

    'use strict';

    models.Brand = Backbone.Model.extend({
        defaults: function () {
            return {
                logo: `${RivalIQ.state.product.get('urlBasepath')}/images/ppt/slideLogo.png`
            };
        },
        // Overwritten to save using state
        save: function () {
            const me = this;
            const state = RivalIQ.state[me.get('settingsType')];

            const deferred = new $.Deferred();

            state.once('persisted:brandCustomization', function () {
                // If this is new branding, add it to the state collection
                if (!me.collection) {
                    RivalIQ.state.branding.add(me);
                }

                deferred.resolve();
                me.trigger('sync');
            });

            state.set({
                brandCustomization: me.toJSON()
            });

            return deferred;
        },

        // Overwritten to destroy using state
        destroy: function () {
            const me = this;
            const state = RivalIQ.state[me.get('settingsType')];

            const deferred = new $.Deferred();

            state.once('persisted:brandCustomization', function () {
                // Destroying the default model simply resets it
                if (me.get('id') === branding.types.DEFAULT) {
                    me.set(branding.getBranding(me.get('id')).attributes, {
                        silent: true
                    });
                } else {
                    me.collection.remove(me);
                }

                deferred.resolve();
                me.trigger('destroy');
            });

            state.set({
                activeBranding: undefined,
                brandCustomization: undefined
            });

            return deferred;
        },

        isDefault: function () {
            const me = this;
            return me.isDefaultLogo();
        },

        isDefaultLogo: function () {
            const defaults = new models.Brand().toJSON();
            return this.toJSON().logo === defaults.logo;
        },

        getLogoPath: function (landscapeId) {
            const me = this;

            const key = {};
            key[branding.types.DEFAULT] = 'default';
            key[branding.types.CUSTOM] = 'custom';

            const url = `/api/branding/${key[me.get('id')]}/logo`;
            return (landscapeId ? `${url}?landscapeId=${encodeURIComponent(landscapeId)}` : url);
        }
    });

    // values copied from branding.less
    const DEFAULT_DARK_GRAY = '#4c535e';
    const DEFAULT_BRANDING_COLORS = {
        'x-default-theme-title-color': DEFAULT_DARK_GRAY,
        'x-default-theme-subtitle-color': DEFAULT_DARK_GRAY,
        'x-default-theme-chart-main-color': '#6a788c',
        'x-default-theme-chart-highlight-color': '#64b0e8',
        'x-default-theme-chart-color-one': '#2c789e',
        'x-default-theme-chart-color-two': '#60bfa6',
        'x-default-theme-chart-color-three': '#aad466',
        'x-default-theme-chart-color-four': '#7ab430',
        'x-default-theme-chart-color-five': '#22955e'
    };

    models.Brand.DEFAULT_COLOR_CLASS_NAMES = [
        'x-default-theme-title-color',
        'x-default-theme-subtitle-color',
        'x-default-theme-chart-main-color',
        'x-default-theme-chart-highlight-color',
        'x-default-theme-chart-color-one',
        'x-default-theme-chart-color-two',
        'x-default-theme-chart-color-three',
        'x-default-theme-chart-color-four',
        'x-default-theme-chart-color-five'
    ];

    (function () {

        models.Brand.getColorsFromClassNames = function (classNames) {
            const classes = classNames || models.Brand.DEFAULT_COLOR_CLASS_NAMES;

            return _.map(classes, function (cls) {
                return {
                    color: DEFAULT_BRANDING_COLORS[cls] || DEFAULT_DARK_GRAY
                };
            });
        };

    }());

    models.Brand.create = function (type, config) {

        const baseAttrs = {};
        baseAttrs[branding.types.DEFAULT] = {
            id: branding.types.DEFAULT,
            name: 'Default Theme',
            scopeName: 'Global',
            settingsType: 'account',
            canDelete: false,
            canRevert: true,
            usageEvent: 'PPTThemeSelectedDefaultForEdit'
        };

        baseAttrs[branding.types.CUSTOM] = {
            id: branding.types.CUSTOM,
            name: 'Custom Theme',
            scopeName: 'This Landscape',
            settingsType: 'landscape',
            canDelete: true,
            canRevert: false,
            usageEvent: 'PPTThemeSelectedCustomForEdit'
        };

        _.defaults(config, baseAttrs[type]);

        return new models.Brand(config);

    };

    models.Brand.createFromSettings = function (type, settings) {

        const brandCustomization = _.get(settings, 'brandCustomization', {});
        const config = _.extend({}, _.pick(brandCustomization, 'logo'));

        return models.Brand.create(type, config);
    };

}, RivalIQ.utils.branding);
